export type MFEligibleIdentity = {
  id: string;
  displayName: string | null;
  username: string | null;
  extId: string;
  integrationName: string | null;
};

export type MFEligibleIdentities = {
  /** A policy says which accounts the request may land on. */
  clauseApplies: boolean;
  requiresChoice: boolean;
  /** Every account it admits when `clauseApplies`, possibly none. */
  identities: MFEligibleIdentity[];
};

export type EligibleIdentitiesQuery = {
  itemId: string;
  catalogItemId: string;
  selectableResourceId: string;
  memberId: string;
  entitlementIds: string[];
};

// itemId → the account ids a policy admits for it. Absent when no policy says
// which account, or when there is no answer to go on.
export type EligibleAccounts = Record<string, string[]>;

export const eligibleIdentitiesPath = ({
  catalogItemId,
  selectableResourceId,
  memberId,
  entitlementIds,
}: EligibleIdentitiesQuery): string => {
  const params = new URLSearchParams({
    sr_id: selectableResourceId,
    member_id: memberId,
  });
  for (const id of entitlementIds) params.append("entitlement_ids[]", id);
  return `/members/access/catalogs/${catalogItemId}/eligible-identities?${params}`;
};

export const eligibleAccountIds = (
  answer: MFEligibleIdentities | undefined,
): string[] | undefined =>
  answer?.clauseApplies ? answer.identities.map((i) => i.id) : undefined;
